// DOM Elements
const cartValueZero = document.getElementById("dhl-initial-text-price-zero");
const cartHasValue = document.getElementById(
  "dhl-text-before-reaching-free-ship"
);
const cartPriceDifference = document.getElementById(
  "dhl-price-value-before-free-ship"
);
const cartValueZeroUps = document.getElementById("ups-initial-text-price-zero");
const cartHasValueUps = document.getElementById(
  "ups-text-before-reaching-free-ship"
);
const cartPriceDifferenceUps = document.getElementById(
  "ups-price-value-before-free-ship"
);
const freeShippingText = document.getElementById(
  "dhl-text-when-reaching-free-ship"
);
const freeShippingTextUps = document.getElementById(
  "ups-text-when-reaching-free-ship"
);
const announcementBarDhl = document.getElementById(
  "shipping-announcement-wrapper-dhl"
);
const announcementBarUps = document.getElementById(
  "shipping-announcement-wrapper-ups"
);
const headingUPS = document.getElementById("versandkosten--text-ups");
const headingDHL = document.getElementById("versandkosten--text-dhl");
const headingUPSCart = document.getElementById(
  "versandkosten--text-ups-cart-page"
);
const headingDHLCart = document.getElementById(
  "versandkosten--text-dhl-cart-page"
);
const progressWrapperDHL = document.getElementById("progress-wrapper-dhl");
const progressWrapperDHLCartPage = document.getElementById(
  "cart-page-progress-wrapper-dhl"
);
const progressWrapperUPS = document.getElementById("progress-wrapper-ups");
const progressWrapperUPSCartPage = document.getElementById(
  "cart-page-progress-wrapper-ups"
);
const progressBarDHL = document.getElementById("progress-bar-dhl");
const progressBarDHLCartPage = document.getElementById(
  "cart-page-progress-bar-dhl"
);
const dhlPriceDifference = document.getElementById("dhl-price-difference");
const dhlPriceDifferenceCartPage = document.getElementById(
  "cart-page-dhl-price-difference"
);
const progressBarUPS = document.getElementById("progress-bar-ups");
const progressBarUPSCartPage = document.getElementById(
  "cart-page-progress-bar-ups"
);
const upsPriceDifference = document.getElementById("ups-price-difference");
const upsPriceDifferenceCartPage = document.getElementById(
  "cart-page-ups-price-difference"
);

// Constants (cart values in cents). NOTE: these only DISPLAY prices — the fee
// actually charged is configured in Shopify Admin → Settings → Shipping and
// must be kept in sync. See docs/adr/0001-shipping-tiers-and-progress-bar-anchoring.md
var mmAT = /(^|\.)mao-mao\.at$/i.test(location.hostname); // Markets-Domain Österreich: Gruppe-A-Staffeln (10,99/7,99 ab 40/4,99 ab 60/frei ab 100), kein TK
var mmCH = /(^|\.)mao-mao\.ch$/i.test(location.hostname); // Markets-Domain Schweiz: 11,99/8,99 ab 40/5,99 ab 60/frei ab 100, kein TK
const amountForFreeShipping = mmAT ? 10000 : (mmCH ? 10000 : 7000); // DHL frei: DE 70€, AT 100€, CH 100€
const upsAmountForShipping5000 = 5000; // DHL Express: ≥50€ → 9,99€
const upsAmountForShipping7000 = 7000; // DHL Express: ≥70€ → 6,99€
const upsAmountForFreeShipping = 11000; // DHL Express: free at 110€
const feeProduct = "44645711085836";
const pfandProduct = "44651626365196";

// v5-NOTE: Im v5-Theme existieren die alten Progress-Bar-/Warnungs-Elemente nicht mehr.
// Alle DOM-Zugriffe sind deshalb mit Null-Guards versehen — sonst crasht die Event-Kette
// (ajaxProduct:added / Initial Check) und reisst TK-Gebühr, Pfand-Automatik und TK-Popup mit.

// Functions
async function fetchCart() {
  try {
    const res = await fetch("/cart.json");
    if (!res.ok) {
      console.warn(`fetchCart: /cart.json returned ${res.status}`);
      return null;
    }
    return await res.json();
  } catch (error) {
    console.warn("fetchCart: unable to load cart", error);
    return null;
  }
}

// v18 (260715): addProductToCart/removeProductFromCart/updateProductQuantity geben jetzt
// das fetch-Promise ZURÜCK. Vorher war das fire-and-forget — ein `await addProductToCart()`
// lief sofort weiter, der Reentranz-Guard (mmFeeSyncRunning) gab frei BEVOR die Gebühr im
// Cart war, und ein parallel gestarteter Check sah „keine Gebühr da" → zweites Add →
// TK-Gebühr stand mit Menge 2 im Warenkorb (2× 5,99€ berechnet!).
async function addProductToCart(product_id, qty) {
  let formData = {
    items: [
      {
        id: product_id,
        quantity: qty || 1,
        properties: {
          _Origin: "fee/pfand",
        },
      },
    ],
  };

  return fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      if (response) {
        document.dispatchEvent(new CustomEvent("cart:build"));
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        document.dispatchEvent(new CustomEvent("cart:change"));
        return response.json();
      }
    })
    .catch((error) => {
      console.error("Error in addProductToCart:", error);
      document.dispatchEvent(
        new CustomEvent("ajaxProduct:error", {
          detail: { errorMessage: error.message },
        })
      );
    });
}

async function removeProductFromCart(line) {
  let formData = {
    line: line,
    quantity: 0,
  };

  return fetch(window.Shopify.routes.root + "cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      if (response) {
        document.dispatchEvent(new CustomEvent("product:removed"));
        document.dispatchEvent(new CustomEvent("cart:build"));
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        document.dispatchEvent(new CustomEvent("cart:change"));
        return response.json();
      }
    })
    .catch((error) => {
      console.error("Error in removeProductFromCart:", error);
      document.dispatchEvent(
        new CustomEvent("ajaxProduct:error", {
          detail: { errorMessage: error.message },
        })
      );
    });
}

function updateCartDisplay(cartPrice) {
  const difference = ((amountForFreeShipping - cartPrice) / 100).toString();

  if(cartValueZero) cartValueZero.style.display = cartPrice === 0 ? "block" : "none";
  if(cartHasValue) cartHasValue.style.display = cartPrice > 0 && cartPrice < amountForFreeShipping ? "block" : "none";
  if(freeShippingText) freeShippingText.style.display = cartPrice >= amountForFreeShipping ? "block" : "none";
  if(cartPriceDifference) cartPriceDifference.textContent = difference;
}

// Function to update UPS Cart Display
function updateUpsCartDisplay(cartPrice) {
  const differenceUps = (
    (upsAmountForFreeShipping - cartPrice) /
    100
  ).toString();

  if(cartValueZeroUps) cartValueZeroUps.style.display = cartPrice === 0 ? "block" : "none";
  if(cartHasValueUps) cartHasValueUps.style.display = cartPrice > 0 && cartPrice < upsAmountForFreeShipping ? "block" : "none";
  if(freeShippingTextUps) freeShippingTextUps.style.display = cartPrice >= upsAmountForFreeShipping ? "block" : "none";
  if(cartPriceDifferenceUps) cartPriceDifferenceUps.textContent = differenceUps;
}

function updateProgressBarDHL(cartPrice) {
  if (progressBarDHL) progressBarDHL.value = cartPrice;
  if (progressBarDHLCartPage) {
    progressBarDHLCartPage.value = cartPrice;
  }
}

function updateProgressBarUPS(cartPrice) {
  if (progressBarUPS) progressBarUPS.value = cartPrice;
  if (progressBarUPSCartPage) {
    progressBarUPSCartPage.value = cartPrice;
  }
}

async function addPfandToCart(product_id) {
  await addProductToCart(product_id);
  checkForProductPfand();
}

async function removePfandFromCart(line) {
  await removeProductFromCart(line);
  checkForProductPfand();
}

async function checkForTKFee() {
  const cart = await fetchCart();
  if (!cart) return;
  let isFeeInCart = false;
  let lineFeeIndex = null;
  let shouldFeeBeInCart = false; // Initialize as false

  // Use map to iterate through cart items and apply conditions
  cart.items.map((item, index) => {
    if (item.product_type === "TK") {
      shouldFeeBeInCart = true;
    } else if (item.product_type === "fee") {
      isFeeInCart = true;
      lineFeeIndex = index + 1;
    }
    return item; // map expects a return value
  });

  // Check conditions for adding or removing fee product
  if (isFeeInCart && !shouldFeeBeInCart) {
    await removeProductFromCart(lineFeeIndex);
  } else if (!isFeeInCart && shouldFeeBeInCart) {
    await addProductToCart(feeProduct);
  } else if (isFeeInCart && shouldFeeBeInCart) {
    // v18: Die TK-Gebühr ist IMMER einmalig — Menge hart auf 1 klemmen (Selbstheilung,
    // falls eine Race-Condition oder eine manuelle Mengenänderung sie erhöht hat).
    const feeItem = cart.items[lineFeeIndex - 1];
    if (feeItem && feeItem.quantity !== 1) {
      await updateProductQuantity(lineFeeIndex, 1);
    }
  }
}

async function checkForProductPfand() {
  const cart = await fetchCart();
  if (!cart) return;
  let isFeeInCart = false;
  let lineFeeIndex = null;
  let shouldFeeBeInCart = false; // Initialize as false
  let totalPfandQuantity = 0; // Initialize total Pfand quantity

  // Use map to iterate through cart items and apply conditions
  cart.items.map((item, index) => {
    if (item.product_type === "Pfand") {
      shouldFeeBeInCart = true;
      totalPfandQuantity += item.quantity; // Add the quantity of each Pfand item to the total
    } else if (item.product_type === "pfand_fee") {
      isFeeInCart = true;
      lineFeeIndex = index + 1;
    }
    return item; // map expects a return value
  });

  // Check conditions for adding or removing fee product
  if (isFeeInCart && !shouldFeeBeInCart) {
    await removeProductFromCart(lineFeeIndex);
  } else if (!isFeeInCart && shouldFeeBeInCart) {
    // Pfand-Gebühr direkt mit der korrekten Menge anlegen (steigt automatisch mit den Pfandprodukten)
    await addProductToCart(pfandProduct, totalPfandQuantity || 1);
  } else if (isFeeInCart && shouldFeeBeInCart) {
    const feeItem = cart.items[lineFeeIndex - 1];
    if (totalPfandQuantity === 0) {
      await removeProductFromCart(lineFeeIndex); // Remove the pfand_fee if total Pfand quantity is 0
    } else if (feeItem && feeItem.quantity !== totalPfandQuantity) {
      await updateProductQuantity(lineFeeIndex, totalPfandQuantity); // Update the quantity
    }
  }
}
async function updateProductQuantity(line, quantity) {
  let formData = {
    line: line,
    quantity: quantity,
  };

  return fetch(window.Shopify.routes.root + "cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      if (response) {
        document.dispatchEvent(new CustomEvent("cart:build"));
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        document.dispatchEvent(new CustomEvent("cart:change"));
        return response.json();
      }
    })
    .catch((error) => {
      console.error("Error in updateProductQuantity:", error);
      document.dispatchEvent(
        new CustomEvent("ajaxProduct:error", {
          detail: { errorMessage: error.message },
        })
      );
    });
}

async function checkForTKProductType() {
  const cart = await fetchCart();
  if (!cart) return;
  const hasTKProduct = cart.items.some((item) => item.product_type === "TK");

  if (hasTKProduct) {
    if (progressWrapperDHL) progressWrapperDHL.style.display = "none";
    if (progressWrapperUPS) progressWrapperUPS.style.display = "block";
    if (progressWrapperDHLCartPage) progressWrapperDHLCartPage.style.display = "none";
    if (progressWrapperUPSCartPage) progressWrapperUPSCartPage.style.display = "block";
    if(announcementBarDhl) announcementBarDhl.style.display = "none";
    if(announcementBarUps) announcementBarUps.style.display = "block";
    if(headingUPS) headingUPS.style.display = "block";
    if(headingDHL) headingDHL.style.display = "none";
    if(headingUPSCart) headingUPSCart.style.display = "block";
    if(headingDHLCart) headingDHLCart.style.display = "none";
    updateUpsCartDisplay(cart.total_price);
    // Show the popup if a TK product is found
    popupTKCart();
  } else {
    if(progressWrapperDHL) progressWrapperDHL.style.display = "block";
    if(progressWrapperUPS) progressWrapperUPS.style.display = "none";
    if(progressWrapperDHLCartPage) progressWrapperDHLCartPage.style.display = "block";
    if(progressWrapperUPSCartPage) progressWrapperUPSCartPage.style.display = "none";
    if(announcementBarDhl) announcementBarDhl.style.display = "block";
    if(announcementBarUps) announcementBarUps.style.display = "none";
    if(headingUPS) headingUPS.style.display = "none";
    if(headingDHL) headingDHL.style.display = "block";
    if(headingUPSCart) headingUPSCart.style.display = "none";
    if(headingDHLCart) headingDHLCart.style.display = "block";
    updateCartDisplay(cart.total_price);
  }

  window.dispatchEvent(new Event('resize'));
}
function updateDHLPriceDifference(cartPrice) {
  if (!dhlPriceDifference && !dhlPriceDifferenceCartPage) return;
  // Next-milestone messaging: free DHL shipping (70€) → free gift (100€).
  const giftThreshold = theme.settings.cartGiftThreshold * 100;
  let text = "";

  if (mmAT) {
    // AT (Ländergruppe A): 10,99€ < 40€ / 7,99€ ab 40€ / 4,99€ ab 60€ / GRATIS ab 100€ (+ Gratisgeschenk ab 100€ wie DE)
    if (cartPrice < 4000) {
      const difference = 4000 - cartPrice;
      text = `Noch <span style="font-weight: bold;">${(difference / 100).toFixed(2)}€</span> für Versand von <strong>7,99€</strong>`;
    } else if (cartPrice < 6000) {
      const difference = 6000 - cartPrice;
      text = `Noch <span style="font-weight: bold;">${(difference / 100).toFixed(2)}€</span> für Versand von <strong>4,99€</strong>`;
    } else if (cartPrice < 10000) {
      const difference = 10000 - cartPrice;
      text = `Noch <span style="font-weight: bold;">${(difference / 100).toFixed(2)}€</span> für <strong>Gratis Versand & Gratisgeschenk 🎁</strong>`;
    } else {
      text = '<span style="font-weight: bold;">Glückwunsch — Gratis Versand & Gratisgeschenk!</span>';
    }
    if (dhlPriceDifference) dhlPriceDifference.innerHTML = text;
    if (dhlPriceDifferenceCartPage) {
      dhlPriceDifferenceCartPage.innerHTML = text;
    }
    return;
  }

  if (mmCH) {
    // CH (Schweiz): 11,99€ < 40€ / 8,99€ ab 40€ / 5,99€ ab 60€ / GRATIS ab 100€ (+ Gratisgeschenk ab 100€ wie DE)
    if (cartPrice < 4000) {
      const difference = 4000 - cartPrice;
      text = `Noch <span style="font-weight: bold;">${(difference / 100).toFixed(2)}€</span> für Versand von <strong>8,99€</strong>`;
    } else if (cartPrice < 6000) {
      const difference = 6000 - cartPrice;
      text = `Noch <span style="font-weight: bold;">${(difference / 100).toFixed(2)}€</span> für Versand von <strong>5,99€</strong>`;
    } else if (cartPrice < 10000) {
      const difference = 10000 - cartPrice;
      text = `Noch <span style="font-weight: bold;">${(difference / 100).toFixed(2)}€</span> für <strong>Gratis Versand & Gratisgeschenk 🎁</strong>`;
    } else {
      text = '<span style="font-weight: bold;">Glückwunsch — Gratis Versand & Gratisgeschenk!</span>';
    }
    if (dhlPriceDifference) dhlPriceDifference.innerHTML = text;
    if (dhlPriceDifferenceCartPage) {
      dhlPriceDifferenceCartPage.innerHTML = text;
    }
    return;
  }

  if (cartPrice < amountForFreeShipping) {
    const difference = amountForFreeShipping - cartPrice;
    text = `Noch <span style="font-weight: bold;">${(difference / 100).toFixed(2)}€</span> für Gratis Versand`;
  } else if (cartPrice < giftThreshold) {
    const difference = giftThreshold - cartPrice;
    text = `Noch <span style="font-weight: bold;">${(difference / 100).toFixed(2)}€</span> für ein Gratisgeschenk 🎁`;
  } else {
    text = '<span style="font-weight: bold;">Glückwunsch — Gratis Versand & Gratisgeschenk!</span>';
  }

  if (dhlPriceDifference) dhlPriceDifference.innerHTML = text;
  if (dhlPriceDifferenceCartPage) {
    dhlPriceDifferenceCartPage.innerHTML = text;
  }
}

function updateUPSPriceDifference(cartPrice) {
  if (!upsPriceDifference && !upsPriceDifferenceCartPage) return;
  // Next-milestone messaging: 9,99€ (50€) → 6,99€ (70€) → free gift (100€)
  // → free DHL Express (110€).
  const giftThreshold = theme.settings.cartGiftThreshold * 100;
  let text = "";

  if (cartPrice < upsAmountForShipping5000) {
    const difference = upsAmountForShipping5000 - cartPrice;
    text = `Noch <span style="font-weight: bold;">${(difference / 100).toFixed(2)}€</span> für Versand von <strong>9,99€</strong>`;
  } else if (cartPrice < upsAmountForShipping7000) {
    const difference = upsAmountForShipping7000 - cartPrice;
    text = `Noch <span style="font-weight: bold;">${(difference / 100).toFixed(2)}€</span> für Versand von <strong>6,99€</strong>`;
  } else if (cartPrice < giftThreshold) {
    const difference = giftThreshold - cartPrice;
    text = `Noch <span style="font-weight: bold;">${(difference / 100).toFixed(2)}€</span> für ein Gratisgeschenk 🎁`;
  } else if (cartPrice < upsAmountForFreeShipping) {
    const difference = upsAmountForFreeShipping - cartPrice;
    text = `Noch <span style="font-weight: bold;">${(difference / 100).toFixed(2)}€</span> für <strong>Gratis Express Versand</strong>`;
  } else {
    text = '<span style="font-weight: bold;">Glückwunsch — Gratis Express Versand!</span>';
  }

  if (upsPriceDifference) upsPriceDifference.innerHTML = text;
  if (upsPriceDifferenceCartPage) {
    upsPriceDifferenceCartPage.innerHTML = text;
  }
}

function validateCartRestrictions(cart) {
  const preorderWarning = document.querySelector(".cart__preorder-warning");
  const subscriptionWarning = document.querySelector(".cart__subscription-warning");
  const checkoutButton = document.querySelector(".btn.cart__checkout");
  const allowedVariantIds = theme.settings.subscriptionProductVariants ? theme.settings.subscriptionProductVariants.split(",") : [];
  const excludedProductIds = [44645711085836, 8456831271180, 8454565396748, 44651626365196];

  let hasPreorder = false;
  let hasSubscription = false;
  let hasRegular = false;

  cart.items.forEach(item => {
    if (!excludedProductIds.includes(item.product_id)) {
      const isPreorder = !!(item.properties && item.properties['_minimum_quantity']);
      const isSubscription = allowedVariantIds.includes(item.variant_id.toString());

      if (isPreorder) {
        hasPreorder = true;
      } else if (isSubscription) {
        hasSubscription = true;
      } else {
        hasRegular = true;
      }
    }
  });

  const showPreorderError = hasPreorder && (hasRegular || hasSubscription);
  const showSubscriptionError = hasSubscription && (hasRegular || hasPreorder);

  if (preorderWarning) preorderWarning.style.display = showPreorderError ? "flex" : "none";
  if (subscriptionWarning) subscriptionWarning.style.display = showSubscriptionError ? "flex" : "none";

  if (checkoutButton) {
    if (showPreorderError || showSubscriptionError) {
      checkoutButton.setAttribute("disabled", "disabled");
    } else {
      checkoutButton.removeAttribute("disabled");
    }
  }
}

// Event Listeners
// v18 (260715): Fee-Checks laufen NUR noch über mmFeeSync (serialisiert + debounced).
// Vorher riefen cart:updated, ajaxProduct:added, Initial Check und der cart:change-Sync
// dieselben Checks PARALLEL auf → Doppel-Add-Race bei der TK-Gebühr (Menge 2).
document.addEventListener("cart:updated", async (evt) => {
  await mmFeeSync();
  await popupTKCart();
  updateProgressBarDHL(evt.detail.cart.total_price);
  updateDHLPriceDifference(evt.detail.cart.total_price);
  updateProgressBarUPS(evt.detail.cart.total_price);
  updateUPSPriceDifference(evt.detail.cart.total_price);
  validateCartRestrictions(evt.detail.cart);
});

document.addEventListener("ajaxProduct:added", async () => {
  const cart = await fetchCart();
  if (!cart) return;
  await mmFeeSync();
  await popupTKCart();
  updateProgressBarDHL(cart.total_price);
  updateDHLPriceDifference(cart.total_price);
  updateProgressBarUPS(cart.total_price);
  updateUPSPriceDifference(cart.total_price);
  validateCartRestrictions(cart);
});

document.addEventListener("product:removed", async () => {
  const cart = await fetchCart();
  if (!cart) return;
  validateCartRestrictions(cart);
});

// v17 (260711): Drawer-Sync — der v5-Cart-Drawer (header-cart-drawer) feuert bei
// Stepper/Löschen/Quick-Add nur 'cart:change', NICHT 'cart:updated' oder 'ajaxProduct:added'.
// Ohne diesen Listener hinkten Pfand-Gebühren-Menge und TK-Gebühr dem Warenkorb hinterher.
// v18 (260715): mmFeeSync ist jetzt der EINZIGE Einstiegspunkt für alle Fee-Checks
// (auch cart:updated/ajaxProduct:added/Initial Check) — vorher konnten zwei Pfade
// gleichzeitig checkForTKFee ausführen, beide sahen „keine Gebühr", beide addeten → Menge 2.
// Zusätzlich warten die Cart-Helfer jetzt echt auf die Server-Antwort (return fetch) und
// checkForTKFee klemmt die Gebühr-Menge hart auf 1 (Selbstheilung für Alt-Fälle).
let mmFeeSyncTimer = null;
let mmFeeSyncRunning = false;
async function mmFeeSync() {
  if (mmFeeSyncRunning) {
    clearTimeout(mmFeeSyncTimer);
    mmFeeSyncTimer = setTimeout(mmFeeSync, 350);
    return;
  }
  mmFeeSyncRunning = true;
  try {
    await checkForTKFee();
    await checkForProductPfand();
    await checkForTKProductType();
  } finally {
    mmFeeSyncRunning = false;
  }
}
document.addEventListener("cart:change", () => {
  clearTimeout(mmFeeSyncTimer);
  mmFeeSyncTimer = setTimeout(mmFeeSync, 200);
});

// Initial Check
(async () => {
  const cart = await fetchCart();
  await mmFeeSync();
  await popupTKCart();
  const totalPrice = cart
    ? cart.total_price
    : (theme.cartInitial && theme.cartInitial.total_price) || 0;
  updateProgressBarDHL(totalPrice);
  updateDHLPriceDifference(totalPrice);
  updateProgressBarUPS(totalPrice);
  updateUPSPriceDifference(totalPrice);
  if (cart) validateCartRestrictions(cart);
})();

// Cart POPUP — zeigt beim ERSTEN TK-Produkt im Warenkorb den Tiefkühl-Hinweis.
// Flag liegt in localStorage (tkProductAdded) und wird zurückgesetzt, sobald kein TK mehr im Korb ist.
async function popupTKCart() {
  const cart = await fetchCart();
  if (!cart) return;
  const tkProductCount = cart.items.filter(
    (item) => item.product_type === "TK"
  ).length;
  const overlay = document.getElementById("cart--popup-overlay");
  const container = document.getElementById("cart--popup-container");
  const closeBtn = document.getElementById("cart--popup-close-btn");

  // Retrieve tkProductAdded from localStorage
  let tkProductAdded = localStorage.getItem("tkProductAdded") === "true";

  // Reset tkProductAdded if no TK products are in the cart
  if (tkProductCount === 0) {
    tkProductAdded = false;
    localStorage.setItem("tkProductAdded", "false");
  }

  if (overlay && container && closeBtn) {
    // Show popup only if a TK product is added for the first time
    if (tkProductCount > 0 && !tkProductAdded) {
      tkProductAdded = true; // Mark that a TK product has been added
      localStorage.setItem("tkProductAdded", "true"); // Store in localStorage
      overlay.style.display = "block";
      overlay.style.zIndex = "10090"; // ueber Tab-Bar/Header/Drawer

      closeBtn?.addEventListener("click", () => {
        overlay.style.display = "none";
      });

      overlay?.addEventListener("click", (e) => {
        if (e.target !== container && !container.contains(e.target)) {
          overlay.style.display = "none";
        }
      });
    }
  }
}

// Header Collection Items
function updateButtonVisibility(scrollRef) {
  const leftButton = document.querySelector(".left-button");
  const rightButton = document.querySelector(".right-button");

  const scrollLeft = scrollRef?.scrollLeft;
  const scrollWidth = scrollRef?.scrollWidth;
  const clientWidth = scrollRef?.clientWidth;

  // Hide left button when at the very start
  if(leftButton) {
    if (scrollLeft <= 0) {
      leftButton.style.display = "none";
    } else {
      leftButton.style.display = "block";
    }
  }

  // Hide right button when at the end
  if(rightButton) {
    if (scrollLeft >= scrollWidth - clientWidth) {
      rightButton.style.display = "none";
    } else {
      rightButton.style.display = "block";
    }
  }

  // Hide both buttons if all elements are visible
  if (clientWidth >= scrollWidth) {
    if(leftButton) leftButton.style.display = "none";
    if(rightButton) rightButton.style.display = "none";
  }
}

document.addEventListener("DOMContentLoaded", function () {
  // Get a reference to the scroll container
  const scrollRef = document.querySelector(".image-container");

  const scrollLeft = () => {
    if (scrollRef) {
      scrollRef.scrollBy({
        left: -280,
        behavior: "smooth",
      });
      setTimeout(() => updateButtonVisibility(scrollRef), 300);
    }
  };

  const scrollRight = () => {
    if (scrollRef) {
      scrollRef.scrollBy({
        left: 280,
        behavior: "smooth",
      });
      setTimeout(() => updateButtonVisibility(scrollRef), 300);
    }
  };

  // Attach event listeners to buttons
  document.querySelector(".left-button")?.addEventListener("click", scrollLeft);
  document.querySelector(".right-button")?.addEventListener("click", scrollRight);

  // Initialize button visibility
  setTimeout(() => updateButtonVisibility(scrollRef), 100);

  // Update button visibility after each scroll
  scrollRef?.addEventListener("scroll", () => updateButtonVisibility(scrollRef));
});

// Show and Hide Carousel based on scroll:

let lastScrollTop = 0;

window.addEventListener(
  "scroll",
  function () {
    let customCarousel = document.getElementById("custom-carousel");
    if (!customCarousel) {
      return;
    }
    let header = document.querySelector(".site-header");
    let st = window.pageYOffset || document.documentElement.scrollTop;

    if (st > lastScrollTop) {
      // downscroll
      if (!customCarousel.classList.contains("hide-carousel")) {
        customCarousel.classList.add("hide-carousel");
        header.classList.add("no-shadow");
      }
    } else {
      // upscroll
      if (customCarousel.classList.contains("hide-carousel")) {
        customCarousel.classList.remove("hide-carousel");
        header.classList.remove("no-shadow");
      }
    }
    lastScrollTop = st <= 0 ? 0 : st;
  },
  false
);

// Custom Dropdowns
if (window.location.pathname.includes("/products/")) {
  var dropdownBtns = Array.from(document.getElementsByClassName("dropdownBtn"));
  var dropdownContents = Array.from(
    document.getElementsByClassName("dropdownContent")
  );

  // Click event handler
  for (var i = 0; i < dropdownBtns.length; i++) {
    dropdownBtns[i].addEventListener("click", toggleDropdown);
  }

  // Function to toggle a specific dropdown
  function toggleDropdown(e) {
    var button = e.target || e; // Allow passing the button element directly
    var suffix = button.id.slice(-1);
    var prefix =
      button.id.charAt(button.id.length - 2) === "D"
        ? "dropdownContent"
        : "dropdownContent";
    var dropdownContent = document.getElementById(
      prefix + button.id.charAt(button.id.length - 2) + suffix
    );
    var paddingSize = window.innerWidth <= 768 ? 8 : 16;

    if (button.classList.contains("dropdown-active")) {
      button.classList.remove("dropdown-active");
      dropdownContent.style.maxHeight = null;
      dropdownContent.style.padding = "0px";
      return;
    }

    for (var j = 0; j < dropdownBtns.length; j++) {
      dropdownBtns[j].classList.remove("dropdown-active");
      dropdownContents[j].style.maxHeight = null;
      dropdownContents[j].style.padding = "0px";
    }

    button.classList.toggle("dropdown-active");
    dropdownContent.style.padding = paddingSize + "px";

    var totalHeight = dropdownContent.scrollHeight + 100 + "px";
    dropdownContent.style.maxHeight = totalHeight;
  }

  // Function to open a specific dropdown by index
  function openDropdown(index) {
    var button = dropdownBtns[index];
    toggleDropdown(button);
  }

  // Open the first dropdown on load
  openDropdown(0);
}

// Wait for the whole DOM and other scripts to load
window.addEventListener("load", function () {
  // Initialize the first Mutation Observer
  const observer1 = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length) {
        const element = document.getElementById("boom-ui-container");
        if (element) {
          element.style.display = "none";
          setTimeout(function () {
            element.style.display = "block";
          }, 15000);
          observer1.disconnect();
        }
      }
    });
  });

  // Configuration for the first observer
  const config1 = {
    attributes: false,
    childList: true,
    characterData: false,
    subtree: true,
  };

  // Start observing the body of the DOM for the first observer
  observer1.observe(document.body, config1);

  // Initialize the second Mutation Observer
  const observer2 = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === "childList") {
        const elements = document.querySelectorAll(
          ".boom-launcher-frame-container-close"
        );
        for (let i = 0; i < elements.length; i++) {
          elements[i].style.zIndex = "5";
          elements[i].style.setProperty("z-index", "5", "important"); // For !important
        }
      }
    });
  });

  // Configuration for the second observer
  const config2 = {
    attributes: false,
    childList: true,
    characterData: false,
    subtree: true,
  };

  // Start observing the body of the DOM for the second observer
  observer2.observe(document.body, config2);
});

window.addEventListener("load", function () {
  if (window.location.pathname === "/" || window.location.pathname === "/en" || window.location.pathname === "/zh") {
    var current_domain = window.location.hostname;
    var language_code;
    var cellWidth; // Declare cellWidth here

    const updateCarousel = () => {
      const firstCell = document.querySelector(".carousel-custom-cell-image");
      cellWidth = firstCell
        ? firstCell.getBoundingClientRect().width + 10
        : 470;
    };

    if (current_domain === "mao-mao.de/en") {
      language_code = "en";
      updateCarousel();
    } else if (current_domain === "mao-mao.de/zh") {
      language_code = "zh";
      updateCarousel();
    } else if (current_domain === "vi.mao-mao.de") {
      language_code = "vi";
      updateCarousel();
    } else {
      language_code = "default";
      updateCarousel();
    }

    var links = document.getElementsByClassName(
      "carousel-custom-cell-image-link"
    );
    for (var i = 0; i < links.length; i++) {
      if (links[i].classList.contains(language_code)) {
        links[i].style.display = "block";
      } else {
        links[i].style.display = "none";
      }
    }

    const scrollRef = document.querySelector(".image-container-slideshow");
    const leftButton = document.querySelector(".left-button-slideshow");
    const rightButton = document.querySelector(".right-button-slideshow");

    const checkButtonVisibility = () => {
      if (!scrollRef) return;
      if (leftButton) leftButton.style.display = scrollRef.scrollLeft === 0 ? "none" : "block";
      if (rightButton) rightButton.style.display = scrollRef.scrollLeft >= scrollRef.scrollWidth - scrollRef.offsetWidth ? "none" : "block";
    };

    const scrollLeft = () => {
      if (scrollRef) {
        scrollRef.scrollBy({
          left: -cellWidth,
          behavior: "smooth",
        });
      }
      checkButtonVisibility();
    };

    const scrollRight = () => {
      if (scrollRef) {
        scrollRef.scrollBy({
          left: cellWidth,
          behavior: "smooth",
        });
      }
      checkButtonVisibility();
    };

    checkButtonVisibility();

    leftButton?.addEventListener("click", scrollLeft);
    rightButton?.addEventListener("click", scrollRight);
    scrollRef?.addEventListener("scroll", checkButtonVisibility);
  }
});

// Info block Cart Page

// Add event listeners
document.addEventListener("DOMContentLoaded", function () {
  // Check if the device is a mobile device
  if (window.matchMedia("(max-width: 767px)").matches) {
    // Check if the current page is the cart page
    if (window.location.pathname.includes("/cart")) {
      const cartInfoBlocks = document.querySelectorAll(".cart--info-block");

      cartInfoBlocks.forEach(function (block) {
        block.addEventListener("click", toggleInfoBlockVisibility);
        block.addEventListener("touchend", function (event) {
          // Check if the touched element is the link
          if (event.target.closest(".info-block-link")) {
            return; // Allow the default behavior for the link
          }
          event.preventDefault(); // Prevents additional click event
          toggleInfoBlockVisibility();
        });
      });

      // Hide when clicking outside
      document.addEventListener("click", function (event) {
        const infoBlock = document.querySelector(".shipping-infoBlock");
        if (infoBlock && !event.target.closest(".cart--info-block, .shipping-infoBlock")) {
          infoBlock.style.display = "none";
        }
      });
    }
  }
});

// Function to toggle the visibility of the info block
function toggleInfoBlockVisibility() {
  const infoBlock = document.querySelector(".shipping-infoBlock");
  if (!infoBlock) return;
  if (infoBlock.style.display === "block") {
    infoBlock.style.display = "none";
    infoBlock.style.filter = "none";
  } else {
    infoBlock.style.display = "block";
    infoBlock.style.opacity = 1;
    infoBlock.style.visibility = "visible";
    infoBlock.style.filter = "drop-shadow(0 0 10px rgba(0,0,0,.2))";
  }
}
// Removing apps when cart is open!
// Function to check for class changes
function checkClassChanges() {
  const headerCart = document.querySelector("#HeaderCart");
  const boomLauncher = document.querySelector(".boom-launcher");
  if (headerCart) {
    const isHeaderCartActive =
      headerCart.classList.contains("is-active-custom");

    // Apply styles to .boom-launcher
    if (boomLauncher) {
      boomLauncher.style.cssText = isHeaderCartActive
        ? "display: none !important;"
        : "";
    }
  }
}

// Initialize MutationObserver
const observer = new MutationObserver(checkClassChanges);

// Target element to observe
const targetElement = document.querySelector("#HeaderCart");

// Options for the observer
const config = {
  attributes: true,
  attributeFilter: ["class"],
};

// Start observing
if (targetElement) {
  observer.observe(targetElement, config);
}

// Stop observing (optional)
// observer.disconnect();

document.addEventListener("DOMContentLoaded", function () {
  const button = document.querySelector("[data-language-selector]");
  const dropdownList = document.getElementById("data-language-selector");
  const localeInput = document.querySelector("[data-disclosure-input]");

  button?.addEventListener("click", function () {
    dropdownList?.classList.toggle("is-visible");
  });

  dropdownList?.querySelectorAll("[data-disclosure-option]").forEach((option) => {
      option.addEventListener("click", function (event) {
        event.preventDefault(); // Prevent the link from navigating
        let selectedLanguageCode = this.getAttribute("data-value");
        let selectedLanguage = this.textContent.trim();
        // Handle the default language case by correcting the URL
        if (selectedLanguageCode === "de") {
          selectedLanguageCode = ""; // Set to empty for default language to construct the base URL
        }
        // Update button text and input value with the selected language
        button.querySelector(".disclosure-list__label").textContent =
          selectedLanguage;
        localeInput.value = selectedLanguageCode;

        dropdownList?.classList.remove("is-visible"); // Close the dropdown

        // Construct and navigate to the appropriate URL for the selected language
        let newUrl;
        if (selectedLanguageCode === "default") {
          // Navigate to the default language URL (assuming 'default' is the code for the default language)
          newUrl = "https://mao-mao.de";
        } else {
          // Navigate to the URL for the selected language
          newUrl = `https://mao-mao.de/${selectedLanguageCode}`;
        }

        window.location.href = newUrl;
      });
    });

  document.addEventListener(
    "click",
    function (event) {
      if (
        !event.target.closest(".disclosure[data-disclosure-locale]") &&
        !event.target.isEqualNode(button)
      ) {
        dropdownList?.classList.remove("is-visible");
      }
    },
    true
  );
});

// Cart upsell
document.addEventListener("DOMContentLoaded", function() {
  let cartUpsell = document.querySelector(".cart__upsell");
  let cartUpsellAtc = document.querySelector(".cart__upsell-atc");

  cartUpsellAtc?.addEventListener("click", async () => {
    let formData = {
      items: [{
        id: cartUpsellAtc.dataset.variantId,
        quantity: 1
      }],
    };

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    }).then((response) => {
      if (response) {
        document.dispatchEvent(new CustomEvent("ajaxProduct:added"));
        document.dispatchEvent(new CustomEvent("cart:build"));

        cartUpsell.style.display = "none";

        return response.json();
      }
    }).catch((error) => {
      console.error("Error in addProductToCart:", error);
      document.dispatchEvent(
        new CustomEvent("ajaxProduct:error", {
          detail: { errorMessage: error.message },
        })
      );
    });
  });
});